module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-icon-3.e4c4efaaa1c6339cd553e4e42b6babea.png";